module.exports = __webpack_public_path__ + "media/images/new_home/3-jason-wallace-a468a9e1da77ce09c54104ea4813dc1f.png";